<template>
  <nav aria-label="Page navigation">
    <ul v-if="pagination.length" class="pagination justify-content-end">
      <li
        v-for="item in get_pagination"
        :class="{active: item.active, disabled: !item.url}"
        class="page-item">
        <a v-if="item.as_link"
           @click.prevent="fetchData(item.api_url)"
           class="page-link"
           :href="item.url" tabindex="-1" v-html="item.label"></a>
        <span v-else class="page-link" v-html="item.label"></span>
      </li>
    </ul>
  </nav>
</template>

<script>
import axios from 'axios'
import {GET_QUERY_OBJECT_VALUE, REPLACE_IN_QUERY} from "../../helpers/url_helper";

export default {
  name: "Pagination",
  props: {
    pagination: {
      type: Array,
      default: () => []
    },
    fetch_method: {
      type: String,
      default: 'get'
    },
    additional_fetch_data: {
      type: Object,
      default: null
    },
  },
  computed: {
    get_pagination() {
      let url_path = location.pathname
      return this.pagination.map(el => {
        el.as_link = el.url && !el.active
        el.api_url = el.url;
        if (!el.api_url) return el
        let url = new URL(el.url)
        let page = GET_QUERY_OBJECT_VALUE('page', url.search)
        el.url = `${url_path}${REPLACE_IN_QUERY(location.search, 'page', page)}`
        return el
      })
    }
  },
  mounted() {
    window.addEventListener('popstate', this.popstateEvent);
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.popstateEvent);
  },
  methods: {
    popstateEvent() {
      this.$emit('popstateEvent')
    },
    fetchData(api_url) {
      let apiObj = new URL(api_url),
        query = apiObj.search
      if (location.search) {
        let location_search = location.search.replace('?', '').split('&')
        location_search.forEach(group => {
          let [key, val] = group.split('=')
          if (key !== 'page') {
            query += `${query.includes('?') ? '&' : '?'}${key}=${val}`
          }
        })
      }
      let data = {}
      if (this.additional_fetch_data) {
        data = this.fetch_method.toLowerCase() === 'get'
          ? { params: this.additional_fetch_data }
          : this.additional_fetch_data
      }

      axios[this.fetch_method](`${apiObj.origin}${apiObj.pathname}${query}`, data)
        .then(r => {
          history.pushState({}, '', `${location.origin}${location.pathname}${query}`)
          window.scrollTo(0, 0)
          this.$emit('fetch', r.data)
        })
    }
  },
}
</script>
